import React from 'react';
import ExtrusionLayer from './ExtrusionLayer';
import LineLayer from './LineLayer';
import SelectedExtrusionLayer from './SelectedExtrusionLayer';
import SelectedLineLayer from './SelectedLineLayer';

const Layers = ({ data }) => {
	return [
		LineLayer(data),
		SelectedLineLayer(data),
		ExtrusionLayer(data),
		SelectedExtrusionLayer(data),
	]
}


export default Layers;